import axios from 'axios';
import { toast } from 'react-toastify';
import server from '../ServerUrl'

const getToken = () => localStorage.getItem('token');

const AuthService = {
    Signup: async (formData) => {
        try {
            const response = await axios.post(`${server.server}/api/Signup`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            return response;

        } catch (error) {
            console.error(error);
            if (error.response) {
                return `Error: ${error.response.data.message || 'Signup failed'}`;
            } else {
                return 'Network error. Please try again.';
            }
        }
    },
    Login: async (formData) => {
        try {
            const response = await axios.post(`${server.server}/api/Login`, formData);
            return response;

        } catch (error) {
            console.error('Error during login:', error);
            if (error.response) {
                toast.error(error.response.data.message)
                console.error('Response error:', error.response);
                return `Error: ${error.response.data.message || 'Login failed'}`;
            } else if (error.request) {
                console.error('Request error:', error.request);
                return 'No response received. Please check your backend server.';
            } else {
                console.error('Error message:', error.message);
                return `Error: ${error.message}`;
            }
        }
    },
    verifyOtp: async (formData) => {
        try {
            const response = await axios.post(`${server.server}/api/verifyOtp`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            return response;

        } catch (error) {
            console.error(error);
            if (error.response) {
                return `Error: ${error.response.data.message || 'Verification Failed'}`;
            } else {
                return 'Network error. Please try again.';
            }
        }
    },
    resendOtp: async (formData) => {
        try {
            const response = await axios.post(`${server.server}/api/resendOtp`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            return response;

        } catch (error) {
            console.error(error);
            if (error.response) {
                return `Error: ${error.response.data.message || 'OTP Sending Failed'}`;
            } else {
                return 'Network error. Please try again.';
            }
        }
    },
    forgotPassword: async (formData) => {
        try {
            const response = await axios.post(`${server.server}/api/forgotPassword`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            return response;

        } catch (error) {
            console.error(error);
            if (error.response) {
                return `Error: ${error.response.data.message || 'Request for Password reset failed'}`;
            } else {
                return 'Network error. Please try again.';
            }
        }
    },
    changePassword: async (formData) => {
        try {
            const response = await axios.post(`${server.server}/api/changePassword`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            return response;

        } catch (error) {
            console.error(error);
            if (error.response) {
                return `Error: ${error.response.data.message || 'Password Change Failed'}`;
            } else {
                return 'Network error. Please try again.';
            }
        }
    },
    updateActiveStatus: async (formData, navigate = null) => {
        const token = getToken();

        try {
            const response = await axios.post(`${server.server}/updateActiveStatus`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response.data;

        } catch (error) {
            console.error(error);
            if (error.message === 'Network Error' && navigate) {
                navigate('/');
                return 'Error: Network Error - Redirecting to home';
            }
            if (error.response) {
                return `Error: ${error.response.data.message || 'updateActiveStatus Failed'}`;
            } else {
                return 'Network error. Please try again.';
            }
        }
    },
    getUserInformation: async (formData, navigate = null) => {
        const token = getToken();

        try {
            const response = await axios.post(`${server.server}/api/getUserInformation`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response.data;

        } catch (error) {
            console.error(error);
            if (error.message === 'Network Error' && navigate) {
                navigate('/');
                return 'Error: Network Error - Redirecting to home';
            }
            if (error.response) {
                return `Error: ${error.response.data.message || 'getUserInformation Failed'}`;
            } else {
                return 'Network error. Please try again.';
            }
        }
    },
    TotalCountForCivilEngineer: async (formData, navigate = null) => {
        const token = getToken();
        try {
            const response = await axios.post(`${server.server}/TotalCountForCivilEngineer`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response.data;

        } catch (error) {
            console.error(error);
            if (error.message === 'Network Error' && navigate) {
                navigate('/');
                return 'Error: Network Error - Redirecting to home';
            }
            if (error.response) {
                return `Error: ${error.response.data.message || 'TotalCountForCivilEngineer Failed'}`;
            } else {
                return 'Network error. Please try again.';
            }
        }
    },
    getTabDataForCivilEngineer: async (formData, navigate = null) => {
        const token = getToken();
        try {
            const response = await axios.post(`${server.server}/getTabDataForCivilEngineer`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response.data;

        } catch (error) {
            console.error(error);
            if (error.message === 'Network Error' && navigate) {
                navigate('/');
                return 'Error: Network Error - Redirecting to home';
            }
            if (error.response) {
                return `Error: ${error.response.data.message || 'getTabDataForCivilEngineer Failed'}`;
            } else {
                return 'Network error. Please try again.';
            }
        }
    },
    handleFileUpload: async (formData, navigate = null) => {
        const token = getToken();
        const getSectionFromUrl = () => {
          const hash = window.location.hash || '';
          if (hash.includes('/requestProperty')) return 'Dcp/form_documents';
          if (hash.includes('/reqProperty')) return 'Dcp/chat_documents';
          if (hash.includes('/soc')) return 'soc';
          if (hash.includes('/kyp')) return 'kyp/form_documents';
          if (hash.includes('/KYPList')) return 'kyp/landuse_document';
          const path = window.location.pathname || '';
          if (path.includes('requestProperty')) return 'Dcp/form_documents';
          if (path.includes('reqProperty')) return 'Dcp/chat_documents';
          if (path.includes('soc')) return 'soc';
          if (path.includes('kyp')) return 'kyp/form_documents';
          if (path.includes('KYPList')) return 'kyp/landuse_document';
          return 'Dcp/form_documents';
        };
        const section = getSectionFromUrl();
        try {
            const response = await axios.post(`${server.server}/FileUpload`, formData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'x-docity-section': section,
                }
            });
            return response.data;

        } catch (error) {
            console.error(error);

            // Normalize error so callers can handle it in their own try/catch
            if (error.message === 'Network Error') {
                if (navigate) {
                    navigate('/');
                }
                throw new Error('Network Error - Redirecting to home');
            }

            if (error.response) {
                const message = error.response.data?.message || 'File upload failed';
                throw new Error(message);
            }

            throw new Error('Network error. Please try again.');
        }
    },
    addDocument: async (formData, navigate = null) => {
        const token = getToken();
        try {
            const response = await axios.post(`${server.server}/AddCivilEngineerDocument`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response.data;

        } catch (error) {
            console.error(error);
            if (error.message === 'Network Error' && navigate) {
                navigate('/');
                return 'Error: Network Error - Redirecting to home';
            }
            if (error.response) {
                return `Error: ${error.response.data.message || 'addDocument Failed'}`;
            } else {
                return 'Network error. Please try again.';
            }
        }
    },
    updateCivilEngData: async (formData, navigate = null) => {
        const token = getToken();
        try {
            const response = await axios.post(`${server.server}/editCivilEngData`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });
            return response.data;
        } catch (error) {
            console.error(error);
            if (error.message === 'Network Error' && navigate) {
                navigate('/');
                return 'Error: Network Error - Redirecting to home';
            }
            if (error.response) {
                return `Error: ${error.response.data.message || 'getTabDataForCivilEngineer Failed'}`;
            } else {
                return 'Network error. Please try again.';
            }
        }
    },
    googleLogin: async (formData) => {
        try {
            const response = await axios.post(`${server.server}/api/google-auth`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            return response;
        } catch (error) {
            if (error.response) {
                return `Error: ${error.response.data.message || 'Google Login Failed'}`;
            } else {
                return 'Network error. Please try again.';
            }
        }
    }
};

export default AuthService;
